module.exports = __webpack_public_path__ + "static/Macbook3-55ac0f5ffd3435b3993f2508496bc139.png";